import { Dsn } from '../../../types/dsn.types';
import type { DsnSortColumn, DsnSortState } from '../dsnTableSorting';

export enum DateFormatType {
  DATE = 'date',
  DATETIME = 'datetime',
}

export interface DsnListItem {
  InstanceId: string;
}

export interface DateFormatOptions {
  type: DateFormatType;
  locale?: string;
}

export interface FlatTableProps {
  data: Dsn[];
  totalCount?: number;
  onPaginationChange: (page: number, pageSize: number) => void;
  currentPage: number;
  pageSize: number;
  initialActiveRowId?: string;
  onSelectedRowsChange?: (selectedRows: Record<string, boolean>) => void;
  isLoading?: boolean;
  sort: DsnSortState;
  onSort: (column: DsnSortColumn, addToExisting?: boolean) => void;
}

export interface TablePagerProps {
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  onPagination: (newPage: number, pageSize?: number) => void;
  pageSizeSelectionOptions: number[];
}

export interface QueryParams {
  top: number;
  count: boolean;
  isTest: boolean;
  isDate: boolean;
  isUser: boolean;
  expand: string[];
}

export interface PaginationState {
  pageSize: number;
  currentPage: number;
  totalCount?: number;
}
